import React, { useState } from 'react';
import AbstractLanding from '../Entity/AbstractLanding';
import { SEO_ENTITY } from '../../constants/EntityName';
import { seoFormData } from '../../datamodels/Seo';
import { getTableHeaders } from '../../utils/forms/FormDataModel';
import AbstractTabs, { TabActiosEventType, TabActiosProps } from '../Entity/AbstractTabs';
import AbstractForm from '../Entity/AbstractForm';
import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import { ContentItem, OnAddArguments, TabContent } from '../../utils/forms/FormInterface';

const SeoPage = () => {
  const [content, setContent] = useState<TabContent>([]);
  const [activeKey, setActiveKey] = useState<string>('0');
  const [showFormComponent, setShowFormComponent] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('Add SEO');
  const tableHeaders: any = getTableHeaders(seoFormData);
  const headerName = 'SEO';

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent(content => content.filter(item => item.key !== key));
    setActiveKey('0');
    shouldRefresh && setRefreshData(prev => !prev);
    if (key === 'a') setShowFormComponent(false);
  };

  const onSuccessful = (id?: string) => {
    if (id === 'create') {
      setShowFormComponent(false);
    }
    onTabClick('0');
    setRefreshData(prev => !prev);
  };

  const onAdd = (argument1: OnAddArguments) => {
    if (!argument1.id) return;
    const tabTitle = argument1.pageUrl || argument1.name || `Edit ${argument1.id}`;
    const newObj: ContentItem = {
      key: argument1.id,
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            entityName={SEO_ENTITY}
            headerName={headerName}
            formHeader={headerName}
            formTemplate={seoFormData}
            onSuccessfulUpdate={onSuccessful}
            closeTab={closeTab}
          />
        </GenericAccordian>
      ),
      tabTitle,
    };
    setContent(prevContent => [...prevContent, newObj]);
    setActiveKey(argument1.id);
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1 && argument1.id) {
      const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
      if (checkArr.length) {
        onTabClick(argument1.id);
      } else {
        onAdd(argument1);
      }
    } else {
      setShowFormComponent(true);
      setUserName('Add SEO');
      onTabClick('a');
    }
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType
  ) => {
    if (action === 'remove') {
      if (targetKey === 'a') {
        setShowFormComponent(false);
        onTabClick('0');
      } else if (typeof targetKey === 'string') {
        onTabClick('0');
        setContent(content => content.filter(item => String(item.key) !== targetKey));
      }
    }
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName="SEO Management"
      onTabClick={onTabClick}
      updateFormVisibility={updateFormVisibility}
      secondTabTitle={userName}
      showFormComponent={showFormComponent}
      content={content}
      formComponent={
        <GenericAccordian>
          <AbstractForm
            isCreateMode={true}
            entityName={SEO_ENTITY}
            headerName={headerName}
            formHeader={headerName}
            formTemplate={seoFormData}
            onSuccessfulUpdate={onSuccessful}
            closeTab={closeTab}
          />
        </GenericAccordian>
      }
    >
      <AbstractLanding
        entityName={SEO_ENTITY}
        headerName={headerName}
        tableHeaders={tableHeaders}
        onAdd={onAddNew}
        refreshData={refreshData}
      />
    </AbstractTabs>
  );
};

export default SeoPage;
